import { setupStore } from "@kubera/common";
import localForage from "localforage";

export const configureStore = () => {
  setupStore(localForage);
};
